import { useParams } from "react-router-dom";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ToastOptions, toast } from "react-toastify";
import { addAvailability } from "../../../../services/warehouses/availability-add";
import { StyledButton } from "../../../../components/Button/button";
import { theme } from "../../../../helpers/theme";
import { Input } from "../../../../components/Input/input";
import { GoBackButton } from "../../../../components/GoBackButton";
import { FormControl, InputLabel, MenuItem, OutlinedInputProps, Select } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { pl } from "date-fns/locale";
import { Dayjs } from "dayjs";
import { useState, useEffect } from "react";
import { StorageAreaAvailabilityGetById } from "../../../../services/warehouses/storage-area-availability-get-by-id";
import { Availability, StorageArea } from "../../../../services/warehouses/storage-area-availability-get-by-id/types";
import { LoadingBackDrop } from "../../../../components/loader";

export const AddAvailabilityForm = () => {
  const { id } = useParams();

  const [storageArea, setStorageArea] = useState<StorageArea[]>([]);

  const [fromDate, setFromDate] = useState<Dayjs | Date | null | undefined>();
  const [toDate, setToDate] = useState<Dayjs | Date | null | undefined>(new Date());
  const [dateError, setDateError] = useState<boolean>(false);
  const [dateFromInvalid, setDateFromInvalid] = useState<string | null>(null);
  const [dateToInvalid, setDateToInvalid] = useState<string | null>(null);


  useEffect(() => {
    if (fromDate === null || toDate === null) {
      setDateError(true);
    } else if (fromDate != null && toDate != null && fromDate > toDate) {
      setDateError(true);
    } else {
      setDateError(false);
    }
  }, [fromDate, toDate]);



  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };


  const body = {
    id_magazyn: String(id),
  };

  const storageAreaAvailabilityGetById = useQuery(["StorageAreaAvailability"], () => StorageAreaAvailabilityGetById(body), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,

    onSuccess(data) {
      setStorageArea(data.data.payload.obszar_skladowania);
    },
  });



  const AddAvailabilityMutation = useMutation(addAvailability, {
    onSuccess: (res) => {
      toast.success("Dodano pomyślnie!", { toastId: "AddedSuccessfully", ...settings });
      // storageAreaAvailabilityGetById.refetch();
      setFromDate(toDate);
      formik.setFieldValue("data_od", toDate);
    },
    // onError: (err) => {
    //   toast.error("Wystąpił błąd!", { toastId: "Error", ...settings });
    // },
  });

  const validationSchema = yup.object({
    powierzchnia_dostepna: yup
      .number()
      .min(0, "Powierzchnia nie może być mniejsza od 0")
      .typeError("Powierzchnia musi być liczbą")
      .required("Powierzchnia jest wymagana"),
  });

  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      // id_obszar_skladowania: storageArea[0]?.id_obszar_skladowania,
      kod: storageArea[0]?.kod,
      powierzchnia_dostepna: 0,
      data_od: fromDate,
      data_do: toDate,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // console.log(toDate)
      const body = {
        id_obszar_skladowania: values.kod,
        powierzchnia_dostepna: values.powierzchnia_dostepna,
        data_od: values.data_od,
        data_do: values.data_do===undefined ? toDate:values.data_do,
      };
      // console.log(body);
      AddAvailabilityMutation.mutate(body);
    },
  });

  const handleFromDateChange = () => {
  storageArea.forEach(d => {
    if (d.id_obszar_skladowania === formik.values.kod) {
      const date =  d.dostepnosc.length!==0 ? d.dostepnosc[0].data_do : new Date();
      setFromDate(date);
      formik.setFieldValue("data_od", date);
    }
  });
  };

  useEffect(() => {
  handleFromDateChange();
  }, [formik.values.kod]);


  const handleToDateChange = (date: Dayjs | Date | null) => {
    setToDate(date);
    formik.setFieldValue("data_do", date);
  };


  if (storageAreaAvailabilityGetById.isLoading || storageAreaAvailabilityGetById.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
    <ButtonWrapper>
    <GoBackButton description={"Powrót"} goToUrl={-1} />
    </ButtonWrapper>
    <BasicFormWrapper onSubmit={formik.handleSubmit}>
      <FormWrapper>
      <FormControl fullWidth>
          <InputLabel id="kod-label">Kod składowania</InputLabel>
          <Select
            placeholder="Kod składowania"
            labelId="kod-label"
            label="Kod składowania"
            id="kod"
            name="kod"

            value={formik.values.kod}
            onChange={formik.handleChange}
            // error={formik.touched.weryfikacja && Boolean(formik.errors.weryfikacja)}
            // helperText={formik.touched.weryfikacja && formik.errors.weryfikacja}
            onBlur={formik.handleBlur}
            // variant="filled"
            style={{ backgroundColor: "white" }}
          >
            {storageArea.map((r: StorageArea) => (
              <MenuItem key={r.id_obszar_skladowania} value={r.id_obszar_skladowania}>
                {r.kod}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Input
          label="Powierzchnia Dostepna"
          id="powierzchnia_dostepna"
          name="powierzchnia_dostepna"
          value={formik.values.powierzchnia_dostepna}
          onChange={formik.handleChange}
          error={formik.touched.powierzchnia_dostepna && Boolean(formik.errors.powierzchnia_dostepna)}
          helperText={formik.touched.powierzchnia_dostepna && formik.errors.powierzchnia_dostepna}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        
        <LocalizationProvider adapterLocale={pl} dateAdapter={AdapterDateFns}>
          <DatePickersWrapper>
            <DesktopDatePicker
              views={["day"]}
              label="Ważny od"
              disabled
              value={fromDate}
              InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
              onError={(error)=>setDateFromInvalid(error)}
              onChange={(newValue) => {
                setFromDate(newValue);
              }}
              renderInput={(params) => (
                <InputWrapper style={{ justifyContent: "flex-start" }}>
                  <Input
                    {...params}
                    helperText={null}
                    variant="filled"
                    sx={{
                      width: "100%",
                      // minWidth: "300px",
                    }}
                  />
                </InputWrapper>
              )}
            />

              <DesktopDatePicker
                views={["day"]}
                label="Ważny do"
                disablePast
                minDate={fromDate}
                value={toDate}
                InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
                onError={(error)=>setDateToInvalid(error)}
                onChange={(newValue) => {
                  handleToDateChange(newValue);
                }}
                renderInput={(params) => (
                  <InputWrapper style={{justifyContent: "flex-end"}}>
                    <Input
                      {...params}
                      helperText={null}
                      variant="filled"
                      sx={{
                        //  marginRight: "13px",
                        width: "100%",
                        // minWidth: "300px",
                      }}
                    />
                  </InputWrapper>
                )}
              />
            </DatePickersWrapper>
          </LocalizationProvider>


        <StyledButton disabled={!formik.isValid || AddAvailabilityMutation.isLoading || dateError || (dateFromInvalid === null ? false : true) || (dateToInvalid === null ? false : true) || formik.values.kod === undefined ? true : false} type="submit" variant="contained">
          Zapisz
        </StyledButton>
      </FormWrapper>
    </BasicFormWrapper>
    </>
  );
};

export default AddAvailabilityForm;

const BasicFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}){
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width:260px;
  max-width:420px;
  gap: 25px;

  @media (${theme.device.laptop}){
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  margin-left: 320px;
`;

const DatePickersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${theme.device.Mlaptop} {
    flex-direction: column;
    gap: 10px;
  }
  width: 100%;
`;

const InputWrapper = styled.div`
  width: 49%;
  display: flex;

  @media ${theme.device.Mlaptop} {
    width: 100%;
  }
`;
